import { render } from "./GiftInquiry.vue?vue&type=template&id=4a0b9ceb&scoped=true"
import script from "./GiftInquiry.vue?vue&type=script&lang=js"
export * from "./GiftInquiry.vue?vue&type=script&lang=js"

import "./GiftInquiry.vue?vue&type=style&index=0&id=4a0b9ceb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0b9ceb"]])

export default __exports__